import { render, staticRenderFns } from "./outlink_page.vue?vue&type=template&id=477e5334&scoped=true"
import script from "./outlink_page.vue?vue&type=script&lang=js"
export * from "./outlink_page.vue?vue&type=script&lang=js"
import style0 from "./outlink_page.vue?vue&type=style&index=0&id=477e5334&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e5334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477e5334')) {
      api.createRecord('477e5334', component.options)
    } else {
      api.reload('477e5334', component.options)
    }
    module.hot.accept("./outlink_page.vue?vue&type=template&id=477e5334&scoped=true", function () {
      api.rerender('477e5334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/website/outlink_page.vue"
export default component.exports